// extracted by mini-css-extract-plugin
export var menuItem = "P_vV d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "P_vW d_Z d_bz d_bP";
export var menuMainLink = "P_vX d_f0 d_dB";
export var menuLink = "P_vY d_f0 d_dB";
export var icon = "P_qm d_bC d_bP";
export var divider = "P_vZ d_bC d_bP";
export var sublinks = "P_v0";
export var link = "P_mC";
export var Link = "P_tv G_tv G_sX G_tg";